var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMolluscs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 350.59 350.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "allergen_bg_color",
    className: "svgBg",
    d: "M350.59 175.3c0,96.82 -78.48,175.29 -175.29,175.29 -96.82,0 -175.3,-78.47 -175.3,-175.29 0,-96.82 78.48,-175.3 175.3,-175.3 96.81,0 175.29,78.48 175.29,175.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "svgText",
    d: "M164.09 102.47c-43.25,0 -78.43,35.18 -78.43,78.43 0,37.07 30.16,67.23 67.23,67.23 30.89,0 56.02,-25.14 56.02,-56.03 0,-24.71 -20.11,-44.82 -44.82,-44.82 -18.54,0 -33.61,15.08 -33.61,33.62 0,15.44 12.56,28.01 28.01,28.01 12.36,0 22.41,-10.05 22.41,-22.41 0,-3.09 -2.51,-5.6 -5.6,-5.6 -3.1,0 -5.61,2.51 -5.61,5.6 0,6.18 -5.02,11.21 -11.2,11.21 -9.27,0 -16.81,-7.54 -16.81,-16.81 0,-12.36 10.05,-22.41 22.41,-22.41 18.54,0 33.61,15.08 33.61,33.61 0,24.72 -20.1,44.82 -44.81,44.82 -30.9,0 -56.03,-25.13 -56.03,-56.02 0,-37.07 30.16,-67.23 67.23,-67.23 49.43,0 89.64,40.21 89.64,89.64l0 11.2c0,6.18 -5.03,11.21 -11.21,11.21l-28.01 0c-3.09,0 -5.6,2.5 -5.6,5.6 0,3.1 2.51,5.6 5.6,5.6l28.01 0c12.36,0 22.42,-10.05 22.42,-22.41l0 -11.2c0,-55.6 -45.24,-100.84 -100.85,-100.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMolluscs);
export default __webpack_public_path__ + "static/media/molluscs.a9a8013ddbd9ec01cd0367ef5c96cf4a.svg";
export { ForwardRef as ReactComponent };